import { loadDetectionData } from '@/utils/ia.utils';
import { useQuery } from '@tanstack/react-query';

export const useDetectionData = (filePath: string | undefined) => {
  return useQuery({
    queryKey: ['detectionData', filePath],
    queryFn: () => loadDetectionData(filePath),
  });
};
